<template>
    <div>
      <Header />
      <main class="app-content">
        <div class="app-title">
          <div>
            <h1><i class="fa fa-dashboard"></i>PERSONELLER</h1>
          </div>
          <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
            <li class="breadcrumb-item"><a href="#">PERSONELLER</a></li>
          </ul>
        </div>
  
        <div class="row">
          <div class="col-md-12">
            <div class="tile">
              <div class="tile-body">
                <table class="table table-hover table-bordered" id="sampleTable">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>İsim</th>
                      <th>Soyisim</th>
                      <th>Telefon</th>
                      <th>İşe Giriş</th>
                      <th>Durum</th>
                      <th>Kayıt Tarihi</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
  
      <Sidebar />
    </div>
  </template>
  <script>
  import Header from "./default/Header";
  import Sidebar from "./default/Sidebar";
  import axios from "axios";
  import store from "../store";
  export default {
    data() {
      return {
        result: {
          id: "",
          name: "",
          surname: "",
          tel: "",
          isegiris: "",
          status: "",
          reg_date: "",
        },
      };
    },
    mounted() {
      window.scrollTo(0, 0);
      var token = localStorage.getItem("token");
      if(!token){
        this.$router.push("/");
      }
      var results = this.result;
      let datas = [];
  
      let url = store.state.base_url + "AslanSahalar/getAllPersonelFilter.php?key=123";
      var datas2 = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        sectionsId: localStorage.getItem("sectionsId"),
      };
  
      axios
        .post(url, JSON.stringify(datas2))
        .then((response) => {
          datas2 = response.data;
          var table = $("#sampleTable").DataTable({
            pageLength: 20,
            order: [[0, 'desc']]
          });
          $.each(datas2, function(index, value) {
            table.row
              .add([
                value["id"],
                value["name"],
                value["surname"],
                value["tel"],
                value["isegiris"],
                value["status"],
                value["reg_date"],
              ])
              .draw(false);
          });
  
          $("#sampleTable tbody").on("click", "tr", function() {
            var data = table.row(this).data();
            results.id = data[0];
         window.location.href = "#/updatepersonel?id=" + results.id;
          });
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
  
    // methods: {
    //   goProducts: function() {
    //     console.log("deneme");
    //     this.router.navigate(["/staff_detail"], {
    //       queryParams: { new_id: this.result.id },
    //     });
    //     console.log(this.results.id);
    //   },
    // },
  
    components: {
      Header,
      Sidebar,
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/PersonelFiltre.vue